// import React, { useRef } from 'react';
// import PropTypes from 'prop-types';

// import DateRange from '../DateRange';
// import InputLabelWrapper from '../InputLabelWrapper';
// import "./input.css";
// import CustomDropdown, { DropdownItem } from './CustomDropdown';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { registerLocale, setDefaultLocale } from "react-datepicker";
// import { es } from 'date-fns/locale/es';
// registerLocale('es', es)



// const InputDate = ({
//   id,
//   label,
//   isSortable,
//   sortDirection,
//   onLabelClick,
//   value,
//   onChange,
//   defaultValue,
//   dropdownItems,
//   handleItemSelection,
//   hasDropDown
// }) => {
//   const inputRef = useRef(null);



//   const onClickHandler = (event) => {
//     event.preventDefault();
//     onLabelClick(event);
//   };

//   return (
//     <InputLabelWrapper
//       label={label}
//       isSortable={isSortable}
//       sortDirection={sortDirection}
//       onLabelClick={onClickHandler}
//     >
//       <div className="relative my-3 mr-1 w-48">

//         <DatePicker
//           id={id}
//           ref={inputRef}
//           selected={value}
//           onChange={onChange}
//           locale="es"
//           placeholderText="MM/DD/YYYY"
//           className='inputDate w-full text-sm text-white placeholder-inputfield-placeholder pl-2 bg-black h-8 border border-inputfield-main focus:border-inputfield-focus focus:outline-none disabled:border-inputfield-disabled pr-10'
//         />
//         {/* <input
//           id={id}
//           className="inputDate w-full text-sm text-white placeholder-inputfield-placeholder pl-2 bg-black h-8 border border-inputfield-main focus:border-inputfield-focus focus:outline-none disabled:border-inputfield-disabled pr-10"
//           type="date"
//           value={value}
//           onChange={onChange}
//           ref={inputRef}
//           style={{
//             appearance: 'none',
//             WebkitAppearance: 'none',
//             MozAppearance: 'none',
//           }}
//           defaultValue={defaultValue}
//         />
//         <button
//           type="button"
//           onClick={() => {
//             if (inputRef.current?.showPicker) {
//               inputRef.current.showPicker();
//             } else {
//               inputRef.current?.focus();
//             }
//           }}
//           className="absolute right-0 mr-8 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white h-8 w-8 flex items-center"
//         // style={{ backgroundColor: "gray" }}
//         >

//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-8 h-5"
//             fill="#6b6b6b"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M8 7V3m8 4V3M3 11h18M5 7h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2z"
//             />
//           </svg>
//         </button> */}
//         {/* class="absolute right-0 top-1/2 mr-8 transform -translate-y-1/2 text-gray-400 hover:text-white h-8 w-8 flex items-center bg-grey-300" */}
//         {hasDropDown &&
//           <div className={"absolute right-0 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white h-8 w-8 flex items-center bg-grey-300"}>
//             <CustomDropdown className={""} dropdownItems={dropdownItems} handleItemSelection={handleItemSelection}
//             />
//           </div >
//         }

//         {/* <button
//           type="button"
//           onClick={() => {
//             if (inputRef.current?.showPicker) {
//               inputRef.current.showPicker();
//             } else {
//               inputRef.current?.focus();
//             }
//           }}
//           className="absolute right-0 top-1/2 mr-8 transform -translate-y-1/2 text-gray-400 hover:text-white h-8 w-8 flex items-center bg-grey-300"
//           style={{ backgroundColor: "gray" }}
//         >

//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-8 h-5"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M8 7V3m8 4V3M3 11h18M5 7h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2z"
//             />
//           </svg>
//         </button> */}

//       </div>
//     </InputLabelWrapper>
//   );
// };

// const noop = () => { };

// InputDate.defaultProps = {
//   value: {},
//   onLabelClick: noop,
// };

// InputDate.propTypes = {
//   id: PropTypes.string,
//   label: PropTypes.string.isRequired,
//   isSortable: PropTypes.bool.isRequired,
//   sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']).isRequired,
//   onLabelClick: PropTypes.func.isRequired,
//   value: PropTypes.shape({
//     /** YYYYMMDD (19921022) */
//     startDate: PropTypes.string,
//     /** YYYYMMDD (19921022) */
//     endDate: PropTypes.string,
//   }),
//   onChange: PropTypes.func.isRequired,
//   dropdownItems: PropTypes.arrayOf<DropdownItem>,
//   handleItemSelection: PropTypes.func.isRequired,
// };

// export default InputDate;

import React, { useRef } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { enUS } from 'date-fns/locale/en-US';
import InputLabelWrapper from '../InputLabelWrapper';
import CustomDropdown, { DropdownItem } from './CustomDropdown';
import "./input.css";
import "./index.css"
registerLocale('enUS', enUS);

interface InputDateProps {
  id?: string;
  label: string;
  isSortable: boolean;
  sortDirection: 'ascending' | 'descending' | 'none';
  onLabelClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  value: Date | null;
  onChange: (date: Date | null) => void;
  dropdownItems?: DropdownItem[];
  handleItemSelection?: (item: DropdownItem) => void;
  hasDropDown?: boolean;
  wrapperClass?: string;
  popperClassName?: string;
  widthFull?: string;
  minDate?: Date;
  maxDate?: Date;
}

const InputDate: React.FC<InputDateProps> = ({
  id,
  label,
  isSortable,
  sortDirection,
  onLabelClick = () => { },
  value,
  onChange,
  dropdownItems,
  handleItemSelection,
  hasDropDown,
  wrapperClass,
  popperClassName,
  widthFull,
  minDate,
  maxDate
}) => {
  const inputRef = useRef<DatePicker | null>(null);

  const onClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    onLabelClick?.(event);
  };

  return (
    <InputLabelWrapper
      label={label}
      isSortable={isSortable}
      sortDirection={sortDirection}
      onLabelClick={onClickHandler}
    // className={}
    >
      <div className={"relative my-3 mr-1 " + widthFull}>
        <DatePicker
          id={id}
          ref={inputRef}
          selected={value}
          onChange={onChange}
          locale="enUS"
          placeholderText="MM/DD/YYYY"
          className='inputDate w-full text-sm text-white placeholder-inputfield-placeholder pl-2 bg-black h-8 border border-inputfield-main focus:border-inputfield-focus focus:outline-none disabled:border-inputfield-disabled pr-10'
          calendarClassName="absolute inset-0 flex items-center justify-center text-white z-9999"
          wrapperClassName={wrapperClass}
          popperClassName={popperClassName}
          minDate={minDate} // This is the key line
          maxDate={maxDate}
        />
        {hasDropDown && (
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white h-8 w-8 flex items-center bg-grey-300">
            <CustomDropdown
              className={""}
              dropdownItems={dropdownItems || []}
              handleItemSelection={handleItemSelection || (() => { })}
            />
          </div>
        )}
      </div>
    </InputLabelWrapper>
  );
};

export default InputDate;
